export default __webpack_public_path__ + "scripts/resource/5bf3af14f76d75a7ccf260001bf6777b.svg";